import fvSubassembly from '../fvSubassembly';

export default class fvChipObj extends fvSubassembly {
    constructor(sContent, parent, system, callback) {
        super(sContent, parent, system);
        this.create();
        if(this.isDelayedWaiting) {
            this.complete = callback;
        } else {
            callback(this);
        }
        // 创建图元
        // 添加path路径
        this.circularDom = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        system.appendChild(this.circularDom);
        this.createSucss(this.circularDom, sContent);
        if(this.lineTypeStyle) {
            if(this.lineTypeStyle.isStereo) {
                this.lineChipeDom = document.createElementNS('http://www.w3.org/2000/svg', 'g');
                system.appendChild(this.lineChipeDom);
            }
        }
        // 创建样式
        this.parent = parent;
        this.createStyle();
    }

    createStyle() {
        this.setPosition();
        this.circularDom.setAttribute("stroke-width", this.borderWidth);
        this.circularDom.style.width=this.width+"px";
        this.circularDom.style.height=this.height+"px";
        this.setBorderColor();
        this.setFillColor();
        // 线型
        super.chooseRenderType(this.lineType, this.circularDom);
        if(this.lineTypeStyle) {
            if(this.lineTypeStyle.isStereo) {
                this.lineChipeDom.innerHTML = "";
                this.drawStereo(this.lineChipeDom, this.circularDom);
            }
        }
    }

    // 设置位置
    setPosition() {
        // 开始点
        let startX = this.calculateCoordinatesInRadiansX(this.cx - this.parent.parentX + this.width, this.width / 2, this.startRadian);
        let startY = this.calculateCoordinatesInRadiansY(this.cy - this.parent.parentY + this.height / 2, this.height / 2, this.startRadian);
        // 结束点
        let endX = this.calculateCoordinatesInRadiansX(this.cx - this.parent.parentX + this.width, this.width / 2, this.endRadian);
        let endY = this.calculateCoordinatesInRadiansY(this.cy - this.parent.parentY + this.height / 2, this.height / 2, this.endRadian);
        // 判断是画大弧度还是小弧度
        let isBigRadian = this.startRadian >= this.endRadian ? 0 : 1;
        this.circularDom.setAttribute('d', `M ${startX}, ${startY} A ${this.width / 2}, ${this.height / 2} 0 ${isBigRadian} 0 ${endX}, ${endY} z`);
    }

    // 设置填充颜色
    setFillColor() {
        let rgbArray = this.color.colorRgb(this.opacity / 255);
        this.circularDom.style.fill = rgbArray;
    }

    // 设置边框颜色
    setBorderColor() {
        this.circularDom.setAttribute("stroke", this.borderColor);
    }

    // 显示隐藏
    isShow(value) {
        value ? this.circularDom.style.display = 'block' : this.circularDom.style.display = 'none';
    }

    init() {
        super.init();
        if (this.endRadian == "3.1") {
            this.endRadian = this.endRadian + "415926";
        }
        if (this.startRadian == "3.1") {
            this.startRadian = this.startRadian + "415926";
        }
        if (this.startRadian == "-3.1") {
            this.startRadian = this.startRadian + "415926";
        }
        if (this.endRadian == "-3.1") {
            this.endRadian = this.endRadian + "415926";
        }
        if(this.endRadian == this.startRadian) {
            this.startRadian -= 0.01;
        }
        this.endRadian = Number(this.endRadian);
        this.startRadian = Number(this.startRadian);
    }

    onDraw() {
        //调用动画 完成动画 更改实时样式
        this.executePreAnimation(this.circularDom);
        this.circularDom.style.transform = `translate(${this.translateX + 'px'}, ${this.translateY + 'px'})`;
    }

    // 用弧度计算X坐标
    calculateCoordinatesInRadiansX(startX, r, radians) {
        // 计算角度
        let deg = 180 / Math.PI * radians;
        return startX - r + r * Math.cos(radians);
    }

    // 用弧度计算Y坐标
    calculateCoordinatesInRadiansY(startY, r, radians) {
        // 计算角度
        let deg = 180 / Math.PI * radians;
        // 判断顺时针还是逆时针 1 = 顺时针  0 = 逆时针
        let isClockwise = radians >= 0 ? 1 : 0;
        return startY + (1 === isClockwise ? 1 : -1) * r * Math.sin(Math.abs(radians));
    }
}



// WEBPACK FOOTER //
// ./src/js/div/divUnit/fvChipObj.js